import type { DTOHashtagInfo } from 'src/apis/dto/DTOHashtagInfo';
import type { DTOProfileCard, DTOProfileCardType } from 'src/apis/dto/DTOProfileCard';
import { DTOProfileImageInfo } from 'src/apis/dto/DTOProfileImageInfo';
import type { DTOUserLanguageEntry } from 'src/apis/dto/DTOUserLanguageEntry';
import { JSONRPCClient } from 'src/apis/service';
import { ProfileCardApiService } from 'src/apis/service/ProfileCardApiService';
import { client } from 'src/utils/api';

export enum ProfileApiList {
  PreferredLanguages = '/api/v1/preferred-languages',
  ProfileNickname = '/api/v1/profiles/nickname',
}

interface UserPreferredLanguageInfo {
  maxPreferredLanguageCount: number;
  preferredLanguages: DTOUserLanguageEntry[];
  preferredLanguageOptions: DTOUserLanguageEntry[];
}

export type GetPreferredLanguagesResponse = UserPreferredLanguageInfo;

export interface UpdatePreferredLanguagesRequest {
  preferredLanguages: DTOUserLanguageEntry[];
}

export type UpdatePreferredLanguagesResponse = UserPreferredLanguageInfo;

export const getProfileAPI = (id: string) =>
  client.get<DTOProfileCard>(`/api/v1/profiles/types/MY_PROFILE/ids/${id}`);

interface UploadProfileImageBody {
  bucketName: string;
  objectName: string;
}
export const uploadProfileImageAPI = async (body: UploadProfileImageBody) =>
  client.post<DTOProfileImageInfo[]>('/api/v1/profiles/images', body);

export const deleteProfileImageAPI = async (profileImageId: number) =>
  client.delete<DTOProfileImageInfo[]>(`/api/v1/profiles/images/${profileImageId}`);

interface OrderProfileImagesBody {
  orders: number[];
}
export const orderProfileImagesAPI = async (body: OrderProfileImagesBody) =>
  client.put<DTOProfileImageInfo[]>('/api/v1/profiles/images/orders', body);

interface UpdateProfileBioBody {
  profileBio: string;
}

export const updateProfileBioAPI = async (body: UpdateProfileBioBody) =>
  client.put<{ result: string }>('/api/v1/profiles/bio', body);

type UpdateMainProfileImageBody = UploadProfileImageBody;

export const updateMainProfileImageAPI = async (body: UpdateMainProfileImageBody) =>
  client.put<DTOProfileImageInfo[]>('/api/v1/profiles/images/main', body);

interface UpdateHashtagsBody {
  hashtags: string[];
}
export const updateHashtagsAPI = async (body: UpdateHashtagsBody) =>
  client.put<DTOHashtagInfo[]>('/api/v1/hashtags', body);

export const getProfileCardAPI = (type: DTOProfileCardType, id: string) =>
  new ProfileCardApiService(new JSONRPCClient()).getProfileCard(type, id);

export interface UpdateProfileNicknameParams {
  nickname: string;
}

export interface UpdateProfileNicknameResponse {
  userId: number;
  currentNickname?: string;
  maskingName: string;
  newNickname?: string;
  reviewState: 'PENDING' | 'ACCEPTED' | 'REJECTED';
  dateUpdated: number;
}
